/** This file sets up the events that get challenges working.
   For a student, it sets up the challenge panels and auto-saving.
   The challenge package is brought in asynchronously, so that this doesn't
   need to depend on the challenge package.
 */
import _ from "underscore";

import $ from "#jquery/jquery-with-scratchpad-plugins.js";

const bindEvents = _.once(function (ScratchpadUI) {
    $(ScratchpadUI).bind({
        started: function (e) {
            if (ScratchpadUI.scratchpad.isChallenge()) {
                // Many of the things we just set up need to see a results object in
                // order to load themselves properly (ChallengePanels) So force
                // liveEditor to re-run the code
                ScratchpadUI.liveEditor.markDirty();
            }
        },

        startCodeOver: function (e) {
            if (ScratchpadUI.scratchpad.isChallenge()) {
                // Student expects to be back at step 1,
                // which is what this effectively does
                // TODO(somewhatabstract): Use WB timing
                // eslint-disable-next-line no-restricted-syntax
                window.setTimeout(function () {
                    ScratchpadUI.challenge.startOver();
                }, 100);
            }
        },

        runCode: function (e, options) {
            if (options.validate) {
                options.validate =
                    ScratchpadUI.scratchpad.get("translatedTests");
            }
        },

        update: function (e, data) {
            // Execution results from the editor
            if (
                data.results &&
                data.results.tests &&
                ScratchpadUI.scratchpad.isChallenge()
            ) {
                ScratchpadUI.challenge.processResults(data.results);
            }
        },
    });
});

export default {
    bindEvents,
};
